import { render, staticRenderFns } from "./ConfigTabAppearance.vue?vue&type=template&id=22a07f11"
import script from "./ConfigTabAppearance.vue?vue&type=script&lang=js"
export * from "./ConfigTabAppearance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports